export function grafanaExpr(query, options = {}) {
    const { json, searchString = "", jsonFilters } = options;
    const hasJsonFilters = !!jsonFilters && Object.keys(jsonFilters).length > 0;
    let q = `{${Object.entries(query)
        .map(([key, value]) => `${key}="${value}"`)
        .join(", ")}} |~ \`(?i)${searchString}\``;
    if (json || hasJsonFilters) {
        q = `${q} | json`;
    }
    if (hasJsonFilters) {
        for (const [key, value] of Object.entries(jsonFilters)) {
            q = `${q} | ${key}="${value}"`;
        }
    }
    return q;
}
export function grafanaExploreURL(query, options = {}) {
    const { host = "gearboxreth.grafana.net" } = options;
    const url = new URL(`https://${host}/explore`);
    url.searchParams.append("schemaVersion", "1");
    url.searchParams.append("panes", JSON.stringify({
        pc8: {
            datasource: "grafanacloud-logs",
            queries: [
                {
                    datasource: {
                        type: "loki",
                        uid: "grafanacloud-logs",
                    },
                    editorMode: "builder",
                    expr: grafanaExpr(query, options),
                    queryType: "range",
                    refId: "A",
                },
            ],
            range: {
                from: "now-6h",
                to: "now",
            },
        },
    }));
    url.searchParams.append("orgId", "1");
    return url.toString();
}
